import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Bookmark — tail notch deepens+shallows subtly, giving the bookmark a
 *  "gentle tug" feel like being pulled off the page. */
export function IcnBookmark(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="bookmark">
      <path d="M4 2h8v12l-4-3-4 3z">
        {animate && (
          <animate
            attributeName="d"
            values="M4 2h8v12l-4-3-4 3z;M4 2h8v12l-4-3.8-4 3.8z;M4 2h8v12l-4-3-4 3z"
            keyTimes="0;0.5;1"
            dur="3s"
            repeatCount="indefinite"
          />
        )}
      </path>
    </Svg>
  );
}
